/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NoteRegular from './note-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NoteRegular {...validProps} />;
}
SvgComponent.iconName = 'noteRegular';

export const NoteRegularIcon = svgIconWrapper(SvgComponent);
